import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class ClassifacaoProgramasServicosService {

  private apiUrl = environment.apiGestorUrlLocal;
  
  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
      params: {}
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  listagemClassificacoes(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/classificacao-software/lista`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletarClassificacao(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/classificacao-software/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getById(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/classificacao-software/${id}`, this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  dropDownAntivirus(): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/antivirus/expressao/dropdown`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownGatilhoAcao(): Observable<any> {
    this.httpOptions.params = '';
    return this.http.get(`${this.apiUrl}api/monitoramento-servicos/dropDownGatilhoAcao`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  alterarClassificacao(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.put(`${this.apiUrl}api/classificacao-software`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  adicionarClassificacao(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/classificacao-software`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
